import makeStyles from '@mui/styles/makeStyles';
import { useDispatch, useSelector } from 'react-redux';
import { contextLinks, simpleLinks } from '../../store/reducers/externalLinks';
import React from 'react';
import CancelIcon from '@mui/icons-material/Cancel';
import IconButton from '@mui/material/IconButton';
import { sendUserAudit, user } from '../../store/reducers/user';
import { patient } from '../../store/reducers/patient';
import * as _isArray from 'lodash/isArray';
import * as _extend from 'lodash/extend';
import * as _isObject from 'lodash/isObject';
import { ExternalLinksAPI } from '../../app/externalLinksApi';
import { patientCurrent } from '../../store/reducers/preferences';
import Grid from '@mui/material/Grid';
import { VitalPacLogoIcon } from '../icons/icons';
import WebIcon from '@mui/icons-material/Web';
import { AUDIT_TYPES } from '../../util/auditUtil';

const useStyles = makeStyles((theme) => ({
    linksItems: {
        padding: 16,
        gap: 20,
    },
    frameBackground: {
        width: '100vw',
    },
    closeIcon: {
        position: 'fixed',
        right: '0',
    },
    link: {
        backgroundColor: '#fff',
        color: 'black',
        cursor: 'pointer',
        minWidth: '150px',
        // width: '150px',
        minHeight: '150px',
        // height: '150px',
        flexBasis: '150px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        borderRadius: 10,
        aspectRatio: '2/1',
        boxShadow: `0px ${theme.palette.mode === 'light' ? 1 : 0}px ${theme.palette.mode === 'light' ? 4 : 0}px 0px rgba(0, 0, 0, 0.25)`,
    },
    linkIcon: {
        height: '70%',
        display: 'flex',
        alignItems: 'center',
    },
    linkText: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        paddingBottom: 10,
        textAlign: 'center',
        paddingLeft: 5,
        minHeight: 55,
        paddingRight: 5,
        fontWeight: 600,
        fontSize: '0.9rem',
    },
    frameHeader: {
        paddingLeft: '10px',
        height: '48px',
        lineHeight: '46px',
        fontSize: '20px',
    },
    frame: {
        width: '100%',
        height: 'calc(100vh - 54px)',
    },
    frameInTab: {
        width: '100%',
        height: 'calc(100vh - 54px - 48px - 50px)',
    },
}));

function Links(props) {
    const classes = useStyles();
    const dispatch = useDispatch();

    const simpleLinksData = useSelector(simpleLinks);
    const contextLinksData = useSelector(contextLinks);
    const patientObject = useSelector(patient);
    const userObject = useSelector(user);
    const preferences = useSelector(patientCurrent);
    const authObject = window.keycloak ? window.keycloak : window.auth;

    const [openLinkFrame, setOpenLinkFrame] = React.useState(false);
    const [sourceLinkFrame, setSourceLinkFrame] = React.useState(null);

    const openLink = (link) => {
        dispatch(
            sendUserAudit(props.patient, AUDIT_TYPES.OPEN_CONTEXT_LINK, {
                link: link.name,
                linkType: link.linkType,
                linkId: link.__id,
            }),
        );

        switch (link.linkType) {
            case 'simple':
            case 'Agyle_simple': {
                buildSimpleLink(link.link).then(
                    (url) => {
                        if (!link.openIniFrame) {
                            window.open(url, link.name);
                        } else {
                            setSourceLinkFrame({ url: url, ...link });
                            setOpenLinkFrame(true);
                        }
                    },
                    () => {
                        //failed
                        console.log('Error while preparing link to external system.');
                    },
                );
                break;
            }
            case 'noContext':
            case 'Agyle_noContext': {
                buildSimpleLink(link.link).then(
                    (url) => {
                        window.open(url, link.name);
                        props.close();
                    },
                    () => {
                        //failed
                        console.log('Error while preparing link to external system.');
                    },
                );
                break;
            }
            case 'vitalPac':
            case 'Agyle_vitalPac': {
                buildVitalPacLink(link.link).then(
                    (vitalpacLink) => {
                        setSourceLinkFrame({ url: vitalpacLink, ...link });
                        setOpenLinkFrame(true);
                    },
                    () => {
                        //failed
                        console.log('Error while preparing link to external system.');
                    },
                );
                break;
            }
            case 'ice':
            case 'Agyle_ice': {
                buildICELink(link.link).then(
                    (iceLink) => {
                        setSourceLinkFrame({ url: iceLink, ...link });
                        setOpenLinkFrame(true);
                    },
                    () => {
                        //failed
                        console.log('Error while preparing link to external system.');
                    },
                );
                break;
            }
            case 'saml':
            case 'Agyle_saml': {
                let samlRequest = {};
                if (link.hasOwnProperty('param2')) {
                    try {
                        let additionalProps = JSON.parse(link.param2);
                        Object.assign(samlRequest, additionalProps);
                    } catch (ex) {
                        console.error('error on paring param2 for SAML context link', ex);
                    }
                }
                const nhsNumber = getBindData('patient', 'nhsNumber');
                if (!nhsNumber || nhsNumber === 'null') {
                    console.warn('NhsNumber not provided', patientObject);
                }
                samlRequest['resourceId'] = nhsNumber;
                ExternalLinksAPI.getSAMLResponse(samlRequest).then(
                    (samlBase64) => {
                        setSourceLinkFrame({ url: '', ...link });
                        setOpenLinkFrame(true);
                        let iframe = document.getElementById('iframeExternalLink');
                        if (iframe) {
                            let form = iframe.contentWindow.document.createElement('form');
                            form.setAttribute('method', 'post');
                            form.setAttribute('action', link.link);
                            let input = iframe.contentWindow.document.createElement('input');
                            input.type = 'hidden';
                            input.name = 'SAMLResponse';
                            input.value = samlBase64.data.toString();
                            form.appendChild(input);
                            iframe.contentWindow.document.body.appendChild(form);
                            form.submit();
                        }
                    },
                    () => {
                        //failed
                        console.log('Error while preparing link to external system.');
                    },
                );
                break;
            }
            case 'eyonix': {
                console.log('eyonix link');
                const data = {
                    login: 'eyonix',
                    password: 'eyonix',
                    redirect: false,
                    path: 'patient/S4794568B/',
                };
                ExternalLinksAPI.getEyonixURL(data).then((response) => {
                    setSourceLinkFrame({ url: response.data.url, ...link });
                    setOpenLinkFrame(true);
                    console.log('Eyonix URL response:', response.data.url);
                });
                break;
            }
            default: {
                console.log('Unsupported link type, or special link type');
            }
        }
    };

    const convertJAC = (text) => {
        let r = '';
        for (let i = 0; i < text.length; i++) {
            let l = text.charCodeAt(i);
            if (i % 2 == 0) {
                l = l + 29;
            } else {
                l = l - 23;
            }
            r += String.fromCharCode(l);
        }
        return r;
    };

    const JacAndBase64 = (text) => {
        return btoa(convertJAC(text));
    };

    const buildSimpleLink = (inputLink) => {
        return new Promise((resolve, reject) => {
            let outputLink = inputLink;
            let paramPattern = /\^\^((\w*|\.)*)\^\^/g;
            let params = outputLink.match(paramPattern);
            if (params && _isArray(params)) {
                params.forEach((param) => {
                    let bindingKey = param.replace(/\^\^/g, '');
                    if (bindingKey.indexOf('.') > 0) {
                        let value = getBindData(bindingKey.split('.')[0], bindingKey.substring(bindingKey.indexOf('.') + 1));
                        if (value && value != null) {
                            outputLink = outputLink.replace(param, value.toString());
                        }
                    }
                });
            }
            if (outputLink.indexOf('^^') < 0) {
                if (outputLink.indexOf('!!!')) {
                    resolve(hashForJAC(outputLink));
                } else {
                    resolve(outputLink);
                }
            } else {
                reject();
            }
        });
    };

    const hashForJAC = (inputLink) => {
        let outputLink = inputLink;
        let paramPattern = /!!!((\w*|\.|\/)*)!!!/g;
        let params = outputLink.match(paramPattern);
        if (params && _isArray(params)) {
            params.forEach((param) => {
                let toHashParam = param.replace(/!!!/g, '');
                outputLink = outputLink.replace(param, JacAndBase64(toHashParam));
            });
        }
        return outputLink;
    };

    const buildVitalPacLink = (inputLink) => {
        return new Promise((resolve, reject) => {
            if (
                'vitalPac' in window.envConfig.externalSystemLinks &&
                _isObject(window.envConfig.externalSystemLinks.vitalPac) &&
                'serviceUrl' in window.envConfig.externalSystemLinks.vitalPac &&
                window.envConfig.externalSystemLinks.vitalPac.serviceUrl
            ) {
                ExternalLinksAPI.getVitalPacAuthenticationCode(window.envConfig.externalSystemLinks.vitalPac).then(
                    (authCode) => {
                        let outputLink = inputLink;
                        outputLink = outputLink.replace('^^vitalPacAuth^^', authCode);
                        buildSimpleLink(outputLink).then(
                            (link) => {
                                resolve(link);
                            },
                            () => {
                                reject();
                            },
                        );
                    },
                    () => {
                        reject();
                    },
                );
            } else {
                console.log('Incorrect or missing vitalPac service URL configuration.');
                reject();
            }
        });
    };

    const buildICELink = (inputLink) => {
        return new Promise((resolve, reject) => {
            if ('ice' in window.envConfig.externalSystemLinks && _isObject(window.envConfig.externalSystemLinks.ice)) {
                let iceData = {};
                Object.keys(window.envConfig.externalSystemLinks.ice).forEach((key) => {
                    let element = window.envConfig.externalSystemLinks.ice[key];
                    if (element.startsWith('^^')) {
                        let bindingInfo = element.replace(/\^\^/g, '');
                        if (bindingInfo.indexOf('.') > 0) {
                            iceData[key] = getBindData(bindingInfo.split('.')[0], bindingInfo.split('.')[1]);
                        } else {
                            console.log('Incorrect configuration for ICE authentication object. ' + key);
                        }
                    } else {
                        iceData[key] = element;
                    }
                });
                ExternalLinksAPI.getICELoginXml(iceData).then(
                    (codedMessage) => {
                        let outputLink = inputLink;
                        outputLink = outputLink.replace('^^ICEEncryptedMessage^^', codedMessage);
                        buildSimpleLink(outputLink).then(
                            (link) => {
                                resolve(link);
                            },
                            () => {
                                reject();
                            },
                        );
                    },
                    () => {
                        reject();
                    },
                );
            } else {
                console.log('Incorrect or missing ICE authentication object.');
                reject();
            }
        });
    };

    const getBindData = (portion, keyEl) => {
        switch (portion) {
            case 'patient':
                if (patientObject) {
                    return encodeURIComponent(getValueByPath(keyEl, patientObject));
                }
                return null;
            case 'user':
                if (keyEl in userObject) {
                    return encodeURIComponent(getValueByPath(keyEl, userObject));
                }
                return null;
            case 'auth':
                if (keyEl in authObject) {
                    return encodeURIComponent(getValueByPath(keyEl, authObject));
                }
                return null;
            case 'property':
                if (keyEl in preferences) {
                    return encodeURIComponent(getValueByPath(keyEl, preferences));
                }
                return null;
            default:
                return null;
        }
    };

    const getValueByPath = (path, object) => {
        if (path && path.length > 0) {
            let pathElements = path.split('.');
            let preference = {};
            _extend(preference, object);
            for (const element of pathElements) {
                if (preference && element in preference) {
                    preference = preference[element];
                } else {
                    preference = null;
                }
            }
            return preference;
        }
        return null;
    };

    const renderLogo = (linkType) => {
        switch (linkType) {
            case 'vitalPac':
                return <VitalPacLogoIcon style={{ display: 'inline-block', width: 70, height: 70 }} />;
            default:
                return <WebIcon style={{ display: 'inline-block', width: 70, height: 70 }} />;
        }
    };

    return (
        <>
            {!openLinkFrame && (
                <Grid container className={classes.linksItems}>
                    {props.patient == null &&
                        simpleLinksData.map((link) => {
                            return (
                                <Grid item xs={6} sm={4} md={2} onClick={() => openLink(link)} className={classes.link} key={link.__id}>
                                    <div className={classes.linkIcon}>{renderLogo(link.linkType)}</div>

                                    <span className={classes.linkText}>{link.name}</span>
                                </Grid>
                            );
                        })}

                    {props.patient != null &&
                        contextLinksData.map((link) => {
                            return (
                                <Grid item xs={6} sm={4} md={2} onClick={() => openLink(link)} className={classes.link} key={link.__id}>
                                    <div className={classes.linkIcon}>{renderLogo(link.linkType)}</div>
                                    <span className={classes.linkText}>{link.name}</span>
                                </Grid>
                            );
                        })}
                </Grid>
            )}

            {openLinkFrame && (
                <div className={classes.frameBackground}>
                    <div className={classes.frameHeader}>
                        <span>{sourceLinkFrame.name}</span>
                        {'close' in props && (
                            <IconButton onClick={props.close} className={classes.closeIcon} size="large">
                                <CancelIcon />
                            </IconButton>
                        )}
                        {!('close' in props) && (
                            <IconButton
                                onClick={() => {
                                    setOpenLinkFrame(false);
                                }}
                                className={classes.closeIcon}
                                size="large"
                            >
                                <CancelIcon />
                            </IconButton>
                        )}
                    </div>

                    <iframe
                        src={sourceLinkFrame.url}
                        className={'close' in props ? classes.frame : classes.frameInTab}
                        id="iframeExternalLink"
                        title="iframeExternalLink"
                    />
                </div>
            )}
        </>
    );
}

export default Links;
